<template lang="">
  <!-- <v-parallax :src="spaceBackground"></v-parallax> -->
  <v-card
    elevation="4"
    style="max-width: 400px; margin-top: 15%;"
    class="mx-auto"
  >
    <v-toolbar
      color="indigo"
      dark
    >
      <v-card-title
        style="-webkit-app-region: drag"
        class="pa-0"
      >
        <span>Welcome</span>
      </v-card-title>
      <v-spacer />
      <v-icon>mdi-briefcase</v-icon>
    </v-toolbar>
    <v-container
      style="-webkit-app-region: no-drag"
    >
      <v-row>
        <v-col
          cols="12"
        >
          <v-alert
            v-if="sessionExpired"
            dense
            type="error"
            outlined
            text
            dismissible
            transition="slide-x-transition"
            class="py-0 text-uppercase"
          >
            Your session have expired pls relogin to continue your work
          </v-alert>
          <v-alert
            v-for="(item, index) in errors"
            :key="index"
            dense
            type="error"
            outlined
            text
            dismissible
            transition="slide-x-transition"
            class="py-0 text-uppercase"
          >
            {{ item[0] }}
          </v-alert>
          <v-text-field
            v-model="user"
            :counter="10"
            prepend-icon="mdi-account"
            label="User"
            required
          />
        </v-col>
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="password"
            :type="!showPassword ? 'password' : 'text'"
            label="Password"
            prepend-icon="mdi-lock"
            :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            required
            @click:append="showPassword = !showPassword"
          />
        </v-col>
        <v-col
          cols="12"
        >
          <v-btn
            color="indigo"
            :loading="loggingIn"
            @click="initLogin"
          >
            Login
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'VLogin',
  data() {
    return {
      user: null,
      password: null,
      showPassword: false,
    }
  },
  watch: {
    // loggedIn (val) {
    //   if (val) {
    //     const { token } = this.$store.state.auth
    //     this.setToken(token)
    //     this.$router.replace({ name: 'Dashboard' })
    //   }
    // },
  },
  computed: {
    ...mapState({
      // loggedIn: state => state.auth.loggedIn,
      branchList: state => state.branchLocation.list,
      errors: state => state.auth.errors,
      loggingIn: state => state.auth.loggingIn,
      sessionExpired: state => state.auth.sessionExpired,
    }),
  },
  methods: {
    async initLogin() {
      // if (this.user === '$__settings' && this.password === 'admin') {
      //   this.$router.push({ name: 'Settings' })
      // }
      const { token = null, stores = [], storeId = '', user } = await this.login({
        username: this.user,
        password: this.password,
      }) ?? {}
      if (!token) return
      this.setBranchList(stores)
      this.setStoreId(storeId)
      this.$router.replace({ name: user.homepage || 'Login' })
    },
    ...mapActions({
      login: 'auth/login',
      setBranchList: 'branchLocation/setBranchList',
      setStoreId: 'settings/setStoreId',
    }),
  },
}
</script>
